import { render, staticRenderFns } from "./NoSidebar.vue?vue&type=template&id=1721ff1d&scoped=true"
import script from "./NoSidebar.vue?vue&type=script&lang=js"
export * from "./NoSidebar.vue?vue&type=script&lang=js"
import style0 from "./NoSidebar.vue?vue&type=style&index=0&id=1721ff1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1721ff1d",
  null
  
)

export default component.exports